import { logout as apiLogout } from 'api/user'
import { removeLastLoginTime } from 'components/lastLoginStorage'
import { REDIRECT_URLS } from 'config'
import { useCallback, useState } from 'react'

function useLogout() {
  const [loggingOut, setLoggingOut] = useState(false)

  const logout = useCallback(async () => {
    setLoggingOut(true)
    removeLastLoginTime()
    await apiLogout()
    window.location.href = REDIRECT_URLS.LOGIN
  }, [])

  return { logout, loggingOut }
}

export default useLogout
